export const NEWSLETTER_URLS = {
  default: 'https://http-toolkit.mailcoach.app/subscribe/a63464bc-1d3f-4318-9229-91061d658373',
  blog: 'https://http-toolkit.mailcoach.app/subscribe/1bc7e8da-ebc9-445e-b746-afe83016d607',
  download: 'https://http-toolkit.mailcoach.app/subscribe/411aab08-147f-4c98-824a-ef3ba95fd263',
};
